import React, { FunctionComponent } from 'react';
import { PerspectiveCamera } from 'three';
import DragControls from './r3f-components/DragControls.tsx/DragControls';
import { useSwitchDefaultCameras } from './TrackerGroups/Content360Wrapper/content360Hooks';
import { useGetCurrentSceneId } from '../hooks/general';
import { useDataStore } from '../zustand';
import { IContent360Scene, ITuple3 } from './r3f-components/component-data-structure';

interface IParentProps {
    enabled: boolean;
    camera: PerspectiveCamera;
    nonDragCamera?: PerspectiveCamera;
    disableVerticalDrag?: boolean;
}

const DragControlsWrapper: FunctionComponent<IParentProps> = ({ enabled, camera: dragCamera, nonDragCamera, disableVerticalDrag }) => {
    const currentSceneId = useGetCurrentSceneId();
    const componentsById = useDataStore(({ componentsById }) => componentsById);
    const currentScene = componentsById?.[currentSceneId] as IContent360Scene | undefined;
    const initialRotation = currentScene?.content360?.initialCameraRotation ? [...currentScene?.content360!.initialCameraRotation] : undefined;
    if (initialRotation) {
        initialRotation[1] = initialRotation[1] + 180;
        initialRotation[0] = initialRotation[0];
    }

    useSwitchDefaultCameras(dragCamera, nonDragCamera);

    return <DragControls enabled={enabled} camera={dragCamera} zoomEnabled={false} initialRotation={initialRotation as ITuple3} verticalMovementFactor={-1} disableVerticalDrag={disableVerticalDrag} enableCameraResetOnSceneLoad/>
}

DragControlsWrapper.displayName = 'dragControlsWrapper';
export default DragControlsWrapper;